import middleware from "./controller";
import configureAmplify from "@/bin/aws/amplifyConfigure";
// eslint-disable-next-line no-unused-vars
import Amplify from "@aws-amplify/auth";
import store from "@/store";
import generateUser from "@/bin/aws/generateUser";

/**
 * Ensures that everything is created
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
async function init(to, from, next) {
  if (store.getters.isInitialized) {
    console.log("Skipping");
    return next();
  }
  //   next();
  try {
    console.log("Starting Initialize");
    let x = await middleware.isInitialized();
    if (x) {
      next();
      return;
    }
    store.commit("setLoading", true);

    let organization = await middleware.fetchOrganization();
    if (organization == null || organization == undefined) {
      //invalid organization
      //go to 404 page
      console.error("Organization not found");
      store.commit("setInitialize", true);
      next({ path: "/notfound" });
      return;
    }

    let domain = window.location.hostname;
    let secure = false;
    if (process.env.VUE_APP_AUTH_COOKIE_DOMAIN != undefined) {
      domain = process.env.VUE_APP_AUTH_COOKIE_DOMAIN;
    }
    console.log("[AUTH] Starting...");
    await configureAmplify(Amplify, organization, domain, secure);
    console.log("[AUTH] Setting org...");

    store.commit("setOrganization", organization);
    console.log("[AUTH] Setting User...");
    await generateUser({ cache: true });
    console.log("[AUTH] Finish User...");

    store.commit("setInitialize", true);

    store.commit("setLoading", true);
    console.log("[AUTH]Next...");
    next();
  } catch (err) {
    console.log("Error Initializing", err);
    next();
  }
}
export default init;
